const Footer = () => {
  return (
    <footer className="bg-white shadow-lg mt-6">
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="text-center text-gray-600">
          <p>© 2024 Denise_M. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
